const predefinedLinkTypes = Object.freeze([
    'website',
    'instagram',
    'youtube',
    'spotify',
    'bandcamp',
    'facebook',
    'x',
    'soundcloud',
    'tiktok',
]);
const matchers = {
    website: url => /^https?:\/\/(www\.)?[a-z0-9-]+\.[a-z]{2,}/i.test(url),
    instagram: url => url.includes('instagram.com'),
    youtube: url => url.includes('youtube.com') || url.includes('youtu.be'),
    spotify: url => url.includes('spotify.com'),
    bandcamp: url => url.includes('bandcamp.com'),
    facebook: url => url.includes('facebook.com'),
    x: url => url.includes('twitter.com') || url.includes('x.com'),
    soundcloud: url => url.includes('soundcloud.com'),
    tiktok: url => url.includes('tiktok.com'),
};
export const normalizeArtistLinks = (links) => {
    var _a;
    const output = [];
    for (const t of predefinedLinkTypes) {
        const match = ((_a = links.find(link => { var _a; return (_a = matchers[t]) === null || _a === void 0 ? void 0 : _a.call(matchers, link.url); })) !== null && _a !== void 0 ? _a : { url: '' });
        match._type = t;
        output.push(match);
    }
    const matchedUrls = new Set(output.map(link => link.url));
    for (const link of links) {
        if (!matchedUrls.has(link.url)) {
            output.push(link);
        }
    }
    return output;
};
//# sourceMappingURL=normalizeArtistLinks.js.map